import { Injectable } from '@angular/core';

import { AnalyticsBase } from '@recruitee/analytics';
import { LocationsQuestionKind } from '@recruitee/offers-types';

import { TemplatesType } from './job-editor.analytics.types';

@Injectable()
export class JobEditorAnalytics extends AnalyticsBase {
  public readonly namespace: string = 'Job Editor';
  public readonly requireViewContext: boolean = true;

  public trackSaveNewUrl(): void {
    this.track('EditURL');
  }

  public trackOverrideTemplates(type: TemplatesType, editStage: boolean): void {
    this.track('OverrideTemplates', { type, editStage });
  }

  public trackEditWorkLocationQuestion({
    questionType,
    isRequired,
  }: {
    questionType: LocationsQuestionKind;
    isRequired: boolean;
  }): void {
    this.track('EditWorkLocationQuestion', { questionType, isRequired });
  }
}
